import { useEffect, useState } from 'react';

export const useGlobalSettings = ({ locale }) => {
  const [shouldHideClickCollect, setShouldHideClickCollect] = useState(false);
  const [vipDiscount, setVipDiscount] = useState(null);

  const getValue = (key) => {
   return typeof localStorage !== 'undefined' && 'getItem' in localStorage
      ? JSON.parse(localStorage.getItem(key))
      : null;
  }

  useEffect(() => {
    try {
      const valueClickCollect = getValue('shouldHideClickCollect');
      const valueVipDiscount = getValue('vipDiscountForUser');

      if (valueClickCollect) {
        const state = valueClickCollect.state || '';
        const shouldHide =
          state === 'all' ||
          (typeof state === 'string' &&
            locale.toLowerCase() === state.toLowerCase());
        setShouldHideClickCollect(shouldHide);
      } else {
        setShouldHideClickCollect(false);
      }

      if (valueVipDiscount) {
        const state = valueVipDiscount.state || null;
        setVipDiscount(state)
      }
    } catch (error) {
      console.error(error);
      setShouldHideClickCollect(null);
    }
  }, [locale]);

  return {
    shouldHideClickCollect,
    vipDiscount,
  };
};
